<template>
  <HRApprovalCard
    :approval="approval"
    :documents="documents"
    :updating="approvalUpdating"
    :saving="approvalSaving"
    :disable="
      approval.approvalStatus !== HR_APPROVAL_STATUSES.pending.value ||
      approvalUpdating
    "
    :approval-status="approval.approvalStatus"
    :applicant-name="approval.employeeName"
    :employer-name="approval.erpOrgName"
    :payroll-cost-center-editable="canEditPayrollCostCenter"
    :editing-employee-details="editingEmployeeDetails"
    :approving="
      approvalSaving && selectedDecision === HR_APPROVAL_STATUSES.approved.value
    "
    :denying="
      approvalSaving && selectedDecision === HR_APPROVAL_STATUSES.denied.value
    "
    :loading-quote-pdf="loadingQuotePDF"
    :hrApprovalDenyOpen="hrApprovalDenyOpen"
    :application="application"
    @editing:employee-details="editingEmployeeDetails = true"
    @cancel:employee-details="cancelEditingEmployeeDetails"
    @update:employee-details="setApproval({ ...approval, ...$event })"
    @update:reason="setApproval({ ...approval, approvalReason: $event })"
    @update:notes="setApproval({ ...approval, approvalNotes: $event })"
    @save:approval-updates="saveApprovalUpdates"
    @approve="approve"
    @deny="deny"
    @decide-later="back"
    @download:quote="openQuoteDocument"
    @open:deny-reason="setHrApprovalDenyOpen(true)"
    @close:deny-reason="setHrApprovalDenyOpen(false)"
  />
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
import { getAsset } from 'ecx.saigon.ui.common';
import { HR_APPROVAL_STATUSES, FEATURES } from '../../utils/constants';
import getUserPermissions from '@/utils/user-permissions';

export default {
  name: 'HRApprovalQuoteWidget',
  data() {
    return {
      HR_APPROVAL_STATUSES,
      documents: [],
      editingEmployeeDetails: false,
      selectedDecision: undefined
    };
  },
  computed: {
    ...mapState('hr', [
      'approvalLoading',
      'approvalUpdating',
      'approvalSaving',
      'loadingQuotePDF',
      'quotePDFHref',
      'approval',
      'hrApprovalDenyOpen',
      'application',
      'approvalSnapshot'
    ]),
    ...mapGetters('user', ['getBrandDocuments']),
    ...mapGetters('hr', ['acceptedQuoteId']),
    canEditPayrollCostCenter() {
      const hasFeature =
        getUserPermissions()[FEATURES.payrollCostCenterEmployer];
      return hasFeature && this.approval.approvalStatus && this.approval.approvalStatus !== HR_APPROVAL_STATUSES.approved.value;
    }
  },
  methods: {
    ...mapMutations('hr', [
      'setApproval',
      'setState',
      'setHrApprovalDenyOpen',
      'setHrApplicationApproval'
    ]),
    ...mapActions('hr', [
      'getHRApproval',
      'approvalDecision',
      'getQuotePDF',
      'updateApproval',
      'updateApproval'
    ]),
    cancelEditingEmployeeDetails() {
      this.editingEmployeeDetails = false;
      this.setApproval({ ...this.approvalSnapshot });
    },
    async openQuoteDocument() {
      if (!this.quotePDFHref) {
        await this.getQuotePDF(this.acceptedQuoteId);
      }
      const win = window.open(this.quotePDFHref, '_blank');
      if (win && win.focus) {
        win.focus();
      }
    },
    approve() {
      this.selectedDecision = HR_APPROVAL_STATUSES.approved.value;
      this.approvalDecision(this.selectedDecision);
    },
    deny() {
      this.selectedDecision = HR_APPROVAL_STATUSES.denied.value;
      this.approvalDecision(this.selectedDecision);
    },
    back() {
      this.$router.push({ name: this.$RouteNames.hrApprovals });
    },
    async saveApprovalUpdates() {
      await this.updateApproval();
      this.editingEmployeeDetails = false;
    }
  },
  async mounted() {
    const brandDocuments = this.getBrandDocuments;
    const agreementUrl = await getAsset(brandDocuments.novatedServiceAgreement);
    const termsUrl = await getAsset(brandDocuments.leaseTerms);
    this.documents = [
      {
        label: 'Novation of a Finance Lease',
        href: agreementUrl
      },
      {
        label: 'Terms & Conditions',
        href: termsUrl
      }
    ];
  },
  components: {
    HRApprovalCard: () => import('../../components/organism/hr-approval-card')
  }
};
</script>
